import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-providerregister',
  templateUrl: './providerregister.component.html',
  styleUrls: ['./providerregister.component.css']
})
export class ProviderregisterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
